// Pure helpers for the AppAside left-nav element list.
//
// The nav is a flat array mixing link elements and DIVIDER separators. Once
// hidden elements are removed, a divider can become redundant: leading,
// trailing, or sitting directly next to another divider with no real nav item
// between them. Rendering those produces stray / doubled horizontal lines
// (e.g. on US companies where the "Comms Hub" link between two dividers is
// hidden). These helpers collapse such redundant dividers.

const DIVIDER_TYPE = 'DIVIDER';
// SPACER renders nothing in the nav loop (no template branch), so it must not
// count as content: a divider followed only by a trailing SPACER is still a
// redundant trailing divider.
const NON_CONTENT_TYPES = new Set([DIVIDER_TYPE, 'SPACER']);

// Returns the elements that should render, given a `shouldHide` predicate, with
// redundant dividers removed. A divider is dropped when it is leading, trailing,
// or immediately preceded by another (already-kept) divider.
export const computeVisibleElements = (elements, shouldHide) => {
  const shown = (elements || []).filter(el => !shouldHide(el));
  const result = [];
  for (const el of shown) {
    if (el.type === DIVIDER_TYPE) {
      const previous = result[result.length - 1];
      // Skip a leading divider, or one that directly follows another divider.
      if (!previous || previous.type === DIVIDER_TYPE) {
        continue;
      }
    }
    result.push(el);
  }
  // Drop trailing dividers (nothing renderable follows them). A trailing SPACER
  // renders nothing, so it does not shield a divider from this cleanup.
  let last = result.length - 1;
  while (last >= 0 && NON_CONTENT_TYPES.has(result[last].type)) {
    if (result[last].type === DIVIDER_TYPE) {
      result.splice(last, 1);
    }
    last -= 1;
  }
  return result;
};
